import React, { useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import Header from '../components/Headers/Header'
import CustomLoader from '../components/Loader/CustomLoader'
import DataTable from 'react-data-table-component'
//import { customStyles } from '../utils/customerTableStyle'
import { customStyles } from '../utils/tableForReferrals'
import useGlobalStyles from '../utils/globalStyles'
import {
  Container,
  Button,
  Grid,
  Typography,
  Box,
  Switch,
  Modal,Snackbar, Alert,TextField,FormControlLabel
} from '@mui/material'
import TableHeader from '../components/TableHeader'
import useStyles from '../components/Section/styles'
import { useHistory } from 'react-router-dom'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import { Icon } from '@iconify/react'
import ChangeCustomerType from '../components/ChangeCustomerType/ChangeCustomerType'

import { gql } from 'apollo-boost'
import { useApolloClient, useQuery,useMutation  } from '@apollo/client'
import ViewWallet from '../components/ViewWallet/ViewWallet'
import { SentimentVeryDissatisfiedTwoTone } from '@mui/icons-material'
import ViewNestCash from '../components/ViewWallet/ViewNestCash'
import ViewNestPass from '../components/ViewWallet/ViewNestPass'
import CancelNestPassModal from '../components/ViewWallet/CancelNestPassModal';

import {
  GetAllCustomerTypes,
  GetCustomerDetailsById,
  GetCustomerWallet
} from '../apollo'
import AddNestCash from '../components/AddNestCash/AddNestCash'
import { GetCustomerReferrelsHistory } from '../apollo'


const GET_CUSTOMER_DETAILS = gql`
  ${GetCustomerDetailsById}
`

const GET_CUSTOMER_TYPE = gql`
  ${GetAllCustomerTypes}
`
const GET_CUSTOMER_WALLET = gql`
  ${GetCustomerWallet}
`
const GET_CUSTOMER_REFERRELS_HISTORY = gql`
  ${GetCustomerReferrelsHistory}
`

const ViewCustomerDetails = props => {
  //   const { t } = props;
  const golbalClasses = useGlobalStyles()
  const classes = useStyles()
  const globalClasses = useGlobalStyles()
  const { t } = props
  const history = useHistory()

  const userType = JSON.parse(localStorage.getItem('user-native')).userType
  const rowDataId = JSON.parse(localStorage.getItem('customerDetails'))
  const handleBackClick = () => {
    history.push('/cs_admin/allcustomers') // Navigate back to ManageCategory component
    localStorage.removeItem('customerDetails')
    localStorage.removeItem('customerTypeLabel')
  }
  const client = useApolloClient()
  const [addVendorModal, setAddVendorModal] = useState(false)
  const [viewWalletModal, setViewWalletModal] = useState(false)
  const [viewNestCashModal, setNestCashModal] = useState(false)
  const [addNestCashModal, setaddNestCashModal] = useState(false)
  const [viewNestPassModal, setViewNestPassModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
const [cancelNestPassModalOpen, setCancelNestPassModalOpen] = useState(false);  
console.log(rowData)
  const openCancelNestPassModal = () => {
      console.log('openCancelNestPassModal called'); // Add this line

    setCancelNestPassModalOpen(true);
  };
  
  const closeCancelNestPassModal = () => {
    setCancelNestPassModalOpen(false);
  };
 
  const openaVeiwNestPassModal = () => {
    setViewNestPassModal(true);
  };
  
  const closeViewNestPassModal = () => {
    setViewNestPassModal(false);
  };
  
   const { data: customerDetails, refetch } = useQuery(GET_CUSTOMER_DETAILS, {
        
        variables: { customerId: rowDataId ? rowDataId._id : null },
        onError: error => {
            const isForbiddenError =
                error && error.graphQLErrors.some(err => err.extensions.code === 'FORBIDDEN');
            if (isForbiddenError) {
                localStorage.removeItem('user-native');
                localStorage.removeItem('restaurant_id');
                client.clearStore();
                props.history.push('/auth/login');
            }
        },
    });

  const { data: customerWalletDetails } = useQuery(GET_CUSTOMER_WALLET, {
    variables: {
        // You need to get customerId from rowDataId, which is parsed from localStorage
        customerId: rowDataId ? rowDataId._id : null,
        skip: 0, 
        limit: 10 
    },
    // This ensures the query doesn't run until rowDataId._id is available
    skip: !rowDataId || !rowDataId._id,
    onError: error => {
        const isForbiddenError =
            error && error.graphQLErrors.some(err => err.extensions.code === 'FORBIDDEN');
        if (isForbiddenError) {
            localStorage.removeItem('user-native');
            localStorage.removeItem('restaurant_id');
            client.clearStore();
            props.history.push('/auth/login');
        }
    },
});
  const { data: workerStatus } = useQuery(GET_CUSTOMER_TYPE, {
    onError: error => {
      const isForbiddenError =
        error &&
        error.graphQLErrors.some(err => err.extensions.code === 'FORBIDDEN')
      if (isForbiddenError) {
        localStorage.removeItem('user-native')
        localStorage.removeItem('restaurant_id')
        client.clearStore()
        props.history.push('/auth/login')
      }
    }
  })

  const optionsworkerStatus = workerStatus
    ? workerStatus.getAllCustomerTypes.map(type => ({
        label: type.name,
        customerType: type.customerType
      }))
    : []
  useEffect(() => {}, [optionsworkerStatus])
  const getCustomerTypeName = customerTypeId => {
    const customerType = optionsworkerStatus.find(
      type => type.customerType === customerTypeId
    )
    return customerType ? customerType.label : 'N/A'
  }
 

  const rowData = customerDetails
    ? customerDetails.getCustomerDetailsById
    : null
  const openaAddVendorModal = () => {
    setAddVendorModal(true)
  }
  const closeAddVendorModal = () => {
    setAddVendorModal(false)
  }
  const openaVeiwWalletModal = () => {
    setViewWalletModal(true)
  }
  const closeViewWalletModal = () => {
    setViewWalletModal(false)
  }
  const openaVeiwNestCahsModal = () => {
    setNestCashModal(true)
  }
  const closeViseNestCashModal = () => {
    setNestCashModal(false)
  }
  const openaAddNestCahsModal = () => {
    setaddNestCashModal(true)
  }
  const closeAddNestCashModal = () => {
    setaddNestCashModal(false)
  }
  // Example of using the state data
  useEffect(() => {
    if (rowData) {
      // Perform actions with rowData as needed
    }
  }, [addVendorModal])

 

  const { data: referralHistory, refetch: refetchReferrals } = useQuery(GET_CUSTOMER_REFERRELS_HISTORY, {
        variables: {
            phone: rowData && rowData.phone, // Ensure phone is from the fetched rowData
            skip: (currentPage - 1) * rowsPerPage,
            limit: rowsPerPage,
        },
        skip: !rowData || !rowData.phone, // Skip if rowData or rowData.phone is null/undefined
        onCompleted: data => {
            // console.log("Referral History Data:", data); // Uncomment for debugging
        },
        onError: error => {
            console.error("GET_CUSTOMER_REFERRELS_HISTORY Error:", error); // Added for debugging
            const isForbiddenError =
                error && error.graphQLErrors.some(err => err.extensions.code === 'FORBIDDEN');
            if (isForbiddenError) {
                localStorage.removeItem('user-native');
                localStorage.removeItem('restaurant_id');
                client.clearStore();
                props.history.push('/auth/login');
            }
        },
    });
  const handlePageChange = (page) => {
   
    setCurrentPage(page);
    const skip = (page - 1) * rowsPerPage;
   
    refetch({ skip: skip, limit: rowsPerPage });
  };
  const handleRowsPerPageChange = (newRowsPerPage, page) => {
   
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1); // Reset page to 1 when rows per page changes
   
    refetch({ skip: 0, limit: newRowsPerPage });
  };

  const referralHistoryColumns = [
    /*{
      name: 'Store ID',
      selector: 'storeId',
      wrap: true,
    },*/
    {
      name: 'Referral Code',
      selector: 'code',
      wrap: true
    },
    /*{
      name: 'Referral Type',
      selector: 'type',
    },*/
    {
      name: 'Referrer Name',
      selector: 'referrerName',
      wrap: true
    },
    /*{
      name: 'Referrer',
      selector: 'referrer',
      wrap: true,
    },*/
    {
      name: 'Referrer Phone',
      selector: 'referrerPhone',
      wrap: true
    },
    {
      name: 'Referee Name',
      selector: 'refereeName',
      wrap: true
    },
    /*{
      name: 'Referee',
      selector: 'referee',
      wrap: true,
    },*/
    {
      name: 'Referee Phone',
      selector: 'refereePhone',
      wrap: true
    },
    {
      name: 'Order ID',
      selector: 'orderId',
      wrap: true
    },
    {
      name: 'Registered Date',
      selector: 'registeredDate',
      format: row => row.registeredDate ? new Date(row.registeredDate).toLocaleDateString() : 'N/A' // Display "N/A" if null
    },
    {
      name: 'Applied Date',
      selector: 'appliedDate',
      format: row => row.appliedDate ? new Date(row.appliedDate).toLocaleDateString() : 'N/A' // Format the date if necessary
    },
    {
      name: '% Applied',
      selector: 'percentageApplied',
      format: row => row.percentageApplied ? `${row.percentageApplied}%` : 'N/A'
    },
    {
      name: 'redeemedDate',
      selector: 'redeemedDate',
      format: row => row.redeemedDate ? new Date(row.redeemedDate).toLocaleDateString() : 'N/A'  // Format the date if necessary
    },
    {
      name: 'Status',
      selector: 'status',
      format: row => {
        switch (row.status) {
          case 0:
            return 'ALL'
          case 1:
            return 'REGISTERED'
          case 2:
            return 'APPLIED'
          case 3:
            return 'REDEEMED'
          default:
            return '' // Return an empty string for unexpected values
        }
      }
    }
  ]

  useEffect(() => {
    localStorage.removeItem('restaurant_id')
  }, [])

  if (!rowData) {
    return <div>Loading...</div>
  }
  const columns = [
    {
      name: 'Label',
      selector: 'label'
    },
    {
      name: 'Delivery Address',
      selector: 'deliveryAddress',
      wrap: true, // Enable text wrapping
      style: {
        textAlign: 'left' // align to the left
      }
    },
    {
      name: 'Details',
      selector: 'details'
    },

    {
      name: 'Selected',
      cell: row => <>{availableStatus(row)}</>
    }
  ]
  const availableStatus = row => {
    return (
      <>
        {row.selected}
        <Switch
          size="small"
          defaultChecked={row.selected}
          onChange={_event => {
            // mutateToggle({ variables: { id: row._id } })
          }}
          style={{ color: 'black' }}
        />
      </>
    )
  }

  return (
    <>
      <Header />

      <Container className={globalClasses.flex}>
        <Box sx={{ textAlign: 'right' }}>
          <Button
            className={golbalClasses.dashbordBtn}
            onClick={handleBackClick}>
            <ArrowBackIosIcon onClick={handleBackClick} /> {t('Back')}
          </Button>
        </Box>
        <Box container className={classes.container}>
          <Box className={classes.flexRow}>
            <Box item className={classes.heading}>
              <Typography variant="h6" className={classes.textWhite}>
                {t('Customer Details')}
              </Typography>
            </Box>
          </Box>
          <Box className={classes.form} style={{ height: '237px' }}>
            <Grid container spacing={1} mt={1} className={classes.section}>
              <Grid item xs={6} md={6}>
                <Typography className={classes.headingText}>
                  Name : {rowData.name ? rowData.name : 'N/A'}
                </Typography>
              </Grid>
              <Grid item xs={6} md={6}></Grid>
              <Grid item xs={12} md={6}>
                <Typography className={classes.headingText}>
                  Phone Number : {rowData.phone ? rowData.phone : 'N/A'}
                </Typography>
              </Grid>
              <Grid item xs={6} md={6}></Grid>
              {/* <Grid item xs={12} md={6} > <Typography  className={classes.headingText} >
       Order Count :{rowData.orderCount  ? rowData.orderCount    :"N/A"}
       </Typography>
     
       </Grid > */}
              <Grid item xs={12} md={6} container alignItems="center">
                {' '}
                <Typography
                  className={classes.headingText}
                  style={{ marginRight: '8px' }}>
                  Customer Type:{getCustomerTypeName(rowData.customerType)}
                </Typography>
               {/* {userType === 1 ? (
                  <Box>
                    <Button
                      className={golbalClasses.dashbordBtn}
                      onClick={openaAddVendorModal}>
                      <Icon
                        icon="ic:baseline-edit"
                        style={{ color: 'white' }}
                      />{' '}
                      {t('Change')}
                    </Button>
                  </Box>
                ) : null}*/}
              </Grid>
              <Grid item xs={6} md={6}></Grid>
              <Grid item xs={12} md={12} container alignItems="center">
                {' '}
                {userType === 1 ? (
                  <Box>
                    <Button
                      className={golbalClasses.dashbordBtn}
                      onClick={openaVeiwWalletModal}>
                      <Icon
                        width="20px"
                        height="20px"
                        icon="flowbite:wallet-solid"
                        style={{ color: 'white' }}
                      />{' '}
                      {t('View Wallet')}
                    </Button>
                    <Button
                      className={golbalClasses.dashbordBtn}
                      onClick={openaVeiwNestCahsModal}>
                      <Icon
                        width="20px"
                        height="20px"
                        icon="flowbite:wallet-solid"
                        style={{ color: 'white' }}
                      />{' '}
                      {t('View Nest Cash')}
                    </Button>
                    <Button
                      className={golbalClasses.dashbordBtn}
                      onClick={openaAddNestCahsModal}>
                      <Icon
                        width="20px"
                        height="20px"
                        icon="flowbite:wallet-solid"
                        style={{ color: 'white' }}
                      />{' '}
                      {t('Add Nest Cash')}
                    </Button>
                    <Button
                      className={golbalClasses.dashbordBtn}
                      onClick={openaVeiwNestPassModal}
                    >
                      <Icon
                        width="20px"
                        height="20px"
                        icon="mdi:card-account-details-outline" // Choose an appropriate icon
                        style={{ color: 'white' }}
                      />{' '}
                      {t('View Nest Pass')}
                    </Button>                                
                    {rowData && rowData.customerType == 18 && (
                      <Button
                        className={golbalClasses.dashbordBtn}
                        onClick={openCancelNestPassModal}
                      >
                        {t('Cancel Nest Pass')}
                      </Button>
                    )}
                  </Box>
                ) : null}
              </Grid>
              <Grid item xs={12} md={12}></Grid>
            </Grid>
          </Box>
        </Box>

        {addVendorModal ? (
          <Grid container>
            <Grid item xs={12} order={{ xs: 2, lg: 1 }}>
              <Grid
                sx={{ display: { xs: 'none', lg: 'block' } }}
                item
                mt={5}
                ml={-2}
                order={{ xs: 1, lg: 2 }}>
                <Modal
                  open={addVendorModal}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                  onClose={closeAddVendorModal}>
                 <ChangeCustomerType
                   data={rowData}
                    onClose={closeAddVendorModal}
                    reload={addVendorModal}
                    refetch={refetch}
                  /> 
                   
                </Modal>
              </Grid>
            </Grid>
          </Grid>
        ) : null}

        {viewWalletModal ? (
          <Grid container>
            <Grid item xs={12} order={{ xs: 2, lg: 1 }}>
              <Grid
                sx={{ display: { xs: 'none', lg: 'block' } }}
                item
                mt={5}
                ml={-2}
                order={{ xs: 1, lg: 2 }}>
                <Modal
                  open={viewWalletModal}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                  onClose={closeViewWalletModal}>
                  <ViewWallet
                    data={rowData}
                    onClose={closeViewWalletModal}
                    reload={viewWalletModal}
                    refetch={refetch}
                  />
                </Modal>
              </Grid>
            </Grid>
          </Grid>
        ) : null}

        {viewNestCashModal ? (
          <Grid container>
            <Grid item xs={12} order={{ xs: 2, lg: 1 }}>
              <Grid
                sx={{ display: { xs: 'none', lg: 'block' } }}
                item
                mt={5}
                ml={-2}
                order={{ xs: 1, lg: 2 }}>
                <Modal
                  open={viewNestCashModal}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                  onClose={closeViseNestCashModal}>
                  <ViewNestCash
                    data={rowData}
                    onClose={closeViseNestCashModal}
                    reload={viewNestCashModal}
                    refetch={refetch}
                  />
                </Modal>
              </Grid>
            </Grid>
          </Grid>
        ) : null}

        {addNestCashModal ? (
          <Grid container>
            <Grid item xs={12} order={{ xs: 2, lg: 1 }}>
              <Grid
                sx={{ display: { xs: 'none', lg: 'block' } }}
                item
                mt={5}
                ml={-2}
                order={{ xs: 1, lg: 2 }}>
                <Modal
                  open={addNestCashModal}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                  onClose={closeAddNestCashModal}>
                  <AddNestCash
                    vendor={rowData}
                    data={rowData}
                    onClose={closeAddNestCashModal}
                    reload={addNestCashModal}
                    refetch={refetch}
                  />
                </Modal>
              </Grid>
            </Grid>
          </Grid>
        ) : null}
            {/* view Nest Pass Modal */}
            {viewNestPassModal ? (
          <Grid container>
            <Grid item xs={12} order={{ xs: 2, lg: 1 }}>
              <Grid
                sx={{ display: { xs: 'none', lg: 'block' } }}
                item
                mt={5}
                ml={-2}
                order={{ xs: 1, lg: 2 }}
              >
                <Modal
                  open={viewNestPassModal}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                  onClose={closeViewNestPassModal}
                >
                  <ViewNestPass
                    customerPhone={rowData ? rowData.phone : ''} // Pass the customer's phone number
                    onClose={closeViewNestPassModal}
                    reload={viewNestPassModal}
                    // You might not need refetch here, as ViewNestPass will handle its own data fetching
                  />
                </Modal>
              </Grid>
            </Grid>
          </Grid>
        ) : null}
        {/* Cancel Nest Pass Modal */}
        {cancelNestPassModalOpen ? (
          <Modal
          open={cancelNestPassModalOpen}
          style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          }}
          onClose={closeCancelNestPassModal}
          >
          <CancelNestPassModal
          open={cancelNestPassModalOpen}
          onClose={closeCancelNestPassModal}
          customerPhone={rowData ? rowData.phone : ''}
          refetch={refetch}
          />
          </Modal>
          ) : null}
        
        <DataTable
          subHeader={true}
          title={<TableHeader title={t('Address Details')} />}
          columns={columns}
          data={rowData.addresses ? rowData.addresses : []}
          pagination
          // progressPending={loading}
          progressComponent={<CustomLoader />}
          // sortFunction={customSort}
          // defaultSortField="email"
          customStyles={customStyles}
          // selectableRows
        />
        <Box mt={2}>
          <DataTable
            subHeader={true}
            title={<TableHeader title={t('Referral History')} />}
            columns={referralHistoryColumns}
            data={
              referralHistory
                ? referralHistory.getCustomerReferrelsHistory.referrelsHistory
                : []
            }
            pagination
            paginationServer
            paginationTotalRows={referralHistory && referralHistory.getCustomerReferrelsHistory && referralHistory.getCustomerReferrelsHistory.totalCount}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handleRowsPerPageChange}
            customStyles={customStyles}
            progressComponent={<CustomLoader />}
            progressPending={!referralHistory}
          />
        </Box>
      </Container>
    </>
  )
}

export default withTranslation()(ViewCustomerDetails)
